module.exports = __webpack_public_path__ + "static/media/done_black_24dp.15dfe709.svg";